import { Box, CircularProgress, Typography, useTheme } from "@material-ui/core";
import React, { useContext } from "react";
import { InputFieldWithSlider } from "../../shared/components/InputFieldWithSlider";
import Text from "../../shared/components/Text";
import { Conditions } from "./components/Conditions";
import MainButton from "../../shared/components/MainButton";
import { LoanConditions } from "../loanApplication/SummaryAndAdjust/LoanSummary/components/LoanConditions";
import { useQuotaAdjustment } from "./hooks/useQuotaAdjustment";
import { AuthContext } from "../../../contexts/AuthContext";
import { AvailableLenders } from "./components/AvailableLenders";

export const QuotaAdjustment = () => {
  const { palette } = useTheme();
  const {
    state: { agent },
  } = useContext(AuthContext);

  const { quota_selection_by_borrower_is_allowed } = agent;

  const {
    invalidTerm,
    getSliderTermAndSetLoanConditions,
    onSubmitModule,
    availableLenders,
    allLenders,
    termMarks,
    loanConditions,
    minTerm,
    allowedMaxTerm,
    selectedTerm,
    termOutOfScope,
    hasMultiplePricings,
  } = useQuotaAdjustment();

  const hideSlider = termMarks && termMarks.length <= 1;
  if (!termMarks || allLenders.length === 0) {
    return (
      <>
        <Box />
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100%"}
          height={"100%"}
          gridGap={16}
        >
          <CircularProgress size={20} />
          <Text tId={"LOADING_LOAN_CONDITIONS"} />
        </Box>
        <Box />
      </>
    );
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gridGap={12}
        mt={quota_selection_by_borrower_is_allowed ? 0 : 2}
      >
        <Conditions
          loanConditions={loanConditions}
          hasMultiplePricings={hasMultiplePricings}
          invalidTerm={invalidTerm}
        />
        <Box display={"flex"} flexDirection={"column"} width={"100%"}>
          {quota_selection_by_borrower_is_allowed && !hideSlider && (
            <InputFieldWithSlider
              labelTid={"TERM"}
              value={
                selectedTerm.value > allowedMaxTerm
                  ? allowedMaxTerm
                  : selectedTerm.value
              }
              onChange={getSliderTermAndSetLoanConditions}
              onChangeCommitted={getSliderTermAndSetLoanConditions}
              min={minTerm}
              max={allowedMaxTerm}
              step={5}
              termMarks={termMarks}
              error={selectedTerm.invalidNumber || selectedTerm.invalidValue}
              InputProps={{
                endAdornment: (
                  <>
                    <Box mr={2}>
                      <Text tId={"MONTHS"} />
                    </Box>
                    {!termMarks && (
                      <i
                        className="icon-edit-input"
                        style={{
                          pointerEvents: "none",
                          opacity: 0.5,
                          verticalAlign: "text-top",
                          fontSize: "25px",
                          color: palette.grey[700],
                        }}
                      />
                    )}
                  </>
                ),
              }}
              hintLabel={
                selectedTerm.invalidNumber ? (
                  <Text>{"INVALID_VALUE"}</Text>
                ) : termOutOfScope ? (
                  <Text
                    tId={"TERM_MUST_BE_BETWEEN_X_AND_Y"}
                    dynamicDataTexts={[minTerm, allowedMaxTerm]}
                  />
                ) : selectedTerm.invalidValue ? (
                  <Text tId={"INVALID_TERM_VALUE"} />
                ) : (
                  <Text
                    tId={"FROM_X_TO_Y_MONTHS"}
                    dynamicDataTexts={[minTerm, allowedMaxTerm]}
                  />
                )
              }
            />
          )}
          <AvailableLenders
            availableLenders={availableLenders}
            allLenders={allLenders}
          />
        </Box>
        <Box
          style={{
            width: "100%",
            minHeight: "200px",
            filter: invalidTerm ? "blur(3px)" : "none",
          }}
        >
          <LoanConditions loanConditions={loanConditions} />
          {hasMultiplePricings && !invalidTerm && (
            <Box mt={2}>
              <Typography variant="caption" color="textSecondary">
                * <Text tId="CONDITIONS_MULTI_PRICING_MESSAGE" />
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <MainButton disabled={invalidTerm} onClick={onSubmitModule} />
    </>
  );
};
